<div class="tile-wrapper">
  @if (!busy) {
    @if (!hasExistingHierarchyFeed) {
      <mat-card class="hierarchy-import">
        <mat-card-title>Hierarchy Import</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
          <form #folderLocationForm="ngForm" (ngSubmit)="fetchFile()">
            <p>Please enter the URL or network path of the folder where your file is located</p>
            <p>Currently only csv files are supported</p>
            <p><span>This folder should be unique</span>, if there are multiple files of that type, the latest file is used</p>
            <p>File path example: \\SSLLT045\c$\hfeed would equate to C:\hfeed if your machine name was SSLLT045</p>
            <mat-card-subtitle>Your file name must start with {{tenantName}}_ and be encoded in UTF-8.</mat-card-subtitle>
            <mat-form-field style="width: 80%">
              <input matInput name="filePath" [(ngModel)]="model.FilePath" placeholder="Folder Location"
                value=""
                required
                >
              @if (!importValid) {
                <mat-hint>
                  <span class="mat-error">{{fetchFileErrorText}}</span>
                </mat-hint>
              }
            </mat-form-field>
            <button mat-raised-button type="submit"
              class="mat-raised-button pull-right"
              color="accent" [disabled]="!folderLocationForm.form.valid">
              Fetch File
            </button>
          </form>
          @if (viewModel) {
            @if (viewModel.FormatError) {
              <div style="padding-top:1em;">
                <span class="error is-flex is-aligned-centre">
                  <mat-icon>highlight_off</mat-icon> {{viewModel.FormatError
                  }}
                </span>
              </div>
            }
            @if (viewModel.Top5Rows) {
              <div class="preview">
                @if (viewModel.Top5Rows.length > 0) {
                  <button mat-raised-button class="mat-accent tableBtn" style="margin-bottom: 10px;" (click)="validate()">
                    <mat-icon>playlist_add_check</mat-icon> Validate File&nbsp;&nbsp;&nbsp;
                  </button>
                }
                <table>
                  <tbody>
                    @for (r of viewModel.Top5Rows; track r) {
                      <tr>
                        @for (c of r; track c) {
                          <td>
                            {{c}}
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            <form #doImportForm="ngForm">
              @if (viewModel.LevelCounts && !viewModel.Failed) {
                <div>
                  <h3>Validated Nodes Summary</h3>
                  @for (l of viewModel.LevelCounts; track l) {
                    <p>
                      <strong>{{l.Key}}</strong>: {{l.Value}}
                    </p>
                  }
                  <p>
                    <span class="error">
                      @if (viewModel.LevelCounts && viewModel.LevelCounts.length === 0) {
                        <strong>No Valid Nodes were found</strong>
                      }
                    </span>
                    <button [disabled]="viewModel.NodeErrors.length > 1 || (viewModel.LevelCounts && viewModel.LevelCounts.length === 0)" class="pull-right mat-primary" mat-raised-button (click)="createFeed()">
                      Create Feed
                    </button>
                  </p>
                </div>
              }
              @if (viewModel.ErrorRows && viewModel.ErrorRows.length > 0) {
                <div style="overflow: scroll;">
                  <hr />
                  <h3>Row Errors</h3>
                  <table>
                    <tbody>
                      @for (r of viewModel.ErrorRows; track r) {
                        <tr>
                          @for (f of r.Fields; track f; let i = $index) {
                            <td [class]="getFieldClass(r, i)">{{f}}</td>
                          }
                        </tr>
                        <tr>
                          <td [attr.colspan]="r.Fields.length">
                            <p>
                              Row Number: <strong>{{r.RowNumber}}</strong>
                            </p>
                            @for (e of r.Errors; track e) {
                              <p>
                                <span class="error">
                                  <mat-icon>highlight_off</mat-icon> {{e.Message}}
                                </span>
                              </p>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (viewModel.WarningRows && viewModel.WarningRows.length > 0) {
                <div style="overflow: scroll;margin-top:1ex;">
                  <hr />
                  <h3>Row Warnings</h3>
                  <table>
                    <tbody>
                      @for (r of viewModel.WarningRows; track r) {
                        <tr>
                          @for (f of r.Fields; track f; let i = $index) {
                            <td>{{f}}</td>
                          }
                        </tr>
                        <tr>
                          <td [attr.colspan]="r.Fields.length">
                            <p>
                              Row Number: <strong>{{r.RowNumber}}</strong>
                            </p>
                            @for (e of r.Warnings; track e) {
                              <p>
                                <span class="warning">
                                  <mat-icon>info</mat-icon> {{e.Message}}
                                </span>
                              </p>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (viewModel.NodeErrors && viewModel.NodeErrors.length > 0) {
                <div>
                  <hr />
                  <h3>Node Errors</h3>
                  @for (n of viewModel.NodeErrors; track n) {
                    <div class="node-error">
                      <p>
                        Description: <strong>{{n.NodeDescription}}</strong>
                      </p>
                      <p>
                        <span class="error"><mat-icon>highlight_off</mat-icon> {{n.Error}}</span>
                      </p>
                    </div>
                  }
                </div>
              }
              @if (viewModel.ValidationError) {
                <div>
                  <div class="node-error">
                    <p>
                      <strong>{{viewModel.ValidationError}}</strong>
                    </p>
                    <p>
                      <span class="error"><mat-icon>highlight_off</mat-icon> {{viewModel.ValidationErrorDetail}}</span>
                    </p>
                  </div>
                </div>
              }
              @if (viewModel.LevelCounts && !hasErrors()) {
                <div class="all-good">
                  <mat-icon>check_circle</mat-icon> No Errors Found
                </div>
              }
            </form>
          }
        </mat-card-content>
      </mat-card>
    }
    @if (hasExistingHierarchyFeed) {
      <mat-card class="hierarchy-import">
        <mat-card-title>Hierarchy Import</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
          <div >
            <p>A Hierarchy feed has already been created for the tenant</p>
            <p><strong>Name: </strong> {{existingFeedConfiguration.Name}}</p>
            <p><strong>Path: </strong>{{existingFeedConfiguration.FilePath}}</p>
            <p>To disable please go to the <a [routerLink]="['../../../', 'feeds', existingFeedConfiguration.Id]" >Feed</a></p>
          </div>
        </mat-card-content>
      </mat-card>
    }
  }
</div>
